import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e4f1f98")

_pushScopeId("data-v-1e4f1f98")
const _hoisted_1 = { class: "final_output_selection_container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "final_output_subtext" }, "CONGRATULATIONS!", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "final_output_title" }, [
  /*#__PURE__*/_createTextVNode(" Your Artwork Is Now "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Ready For The World. ")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "waitlist_modal modal"
}
const _hoisted_5 = { class: "modal_block" }
const _hoisted_6 = { class: "close_container" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "waitlist_title" }, [
  /*#__PURE__*/_createTextVNode("Love What "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("You See?")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "uk-width-3-4 waitlist_subtext" }, " Be the first in the world to know when Thoth goes live! ", -1)
const _hoisted_9 = { class: "mascot_container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AlternateButton = _resolveComponent("AlternateButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("img", {
      class: "uk-width-5-6",
      src: _ctx.imageSelect,
      alt: ""
    }, null, 8, ["src"]),
    _createVNode("a", {
      class: "uk-width-3-4 download_button",
      href: _ctx.imageSelect,
      download: ""
    }, " DOWNLOAD IMAGE ", 8, ["href"]),
    _createVNode(_component_AlternateButton, {
      class: "uk-width-5-6",
      text: "Return to Homepage",
      fontSize: "16px",
      lineHeight: "24px",
      style: 1,
      actionOnClick: _ctx.returnHome
    }, null, 8, ["actionOnClick"]),
    _createVNode(_Transition, {
      name: "fade",
      appear: ""
    }, {
      default: _withId(() => [
        (_ctx.showModal)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("img", {
                    class: "close_button",
                    src: _ctx.closeButton,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args))),
                    alt: "close"
                  }, null, 8, ["src"])
                ]),
                _hoisted_7,
                _hoisted_8,
                _createVNode("button", {
                  class: "join_waitlist_button uk-width-5-6",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToWaitlist && _ctx.goToWaitlist(...args)))
                }, " JOIN WAITLIST "),
                _createVNode("div", _hoisted_9, [
                  _createVNode("img", {
                    class: "mascot",
                    src: _ctx.modalMascot,
                    alt: "thoth-mascot"
                  }, null, 8, ["src"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})